import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    alias: '首页',
    component: Home,
    meta: {
      title: '首页', keepAlive: true
    }
  },
  {
    path: '/home',
    name: 'home',
    alias: '首页',
    component: () => import('@//views/home/home.vue'),
    meta: {
      title: '首页', keepAlive: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@//views/about/index.vue'),
    meta: {
      title: '关于展会',
      keepAlive: true
    }
  },
  {
    path: '/academic',
    name: 'academic',
    component: () => import('@//views/academic/index.vue'),
    meta: {
      title: '学术报告会'
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@//views/service/index.vue'),
    meta: {
      title: '展会服务',
      keepAlive: true
    }
  },
  {
    path: '/download/:id',
    name: 'download',
    component: () => import('@//views/download/index.vue'),
    meta: {
      title: '资料下载'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@//views/contact/index.vue'),
    meta: {
      title: '联系我们',
      keepAlive: true
    }
  },
  {
    path: '/exhibitorList',
    name: 'exhibitorList',
    component: () => import('@/views/exhibitorList/index.vue'),
    meta: {
      title: '展商列表',
      keepAlive: false
    },
  },
  {
    path: '/productList',
    name: 'productList',
    component: () => import('@/views/productList/index.vue'),
    meta: {
      title: '产品列表',
      keepAlive: false
    },
  },
  {
    path: '/exhibitorDetail',
    name: 'exhibitorDetail',
    component: () => import('@/views/exhibitorDetail/index.vue'),
    meta: {
      title: '展商详情',
      keepAlive: false
    },
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('@/views/productDetail/index.vue'),
    meta: {
      title: '产品详情',
      keepAlive: false
    },
  },

  {
    path: '/innerChain',
    name: 'innerChain',
    component: () => import('@/views/innerChain/index.vue'),
    meta: {
      title: 'banner详情',
      keepAlive: false
    },
  },
  {
    path: '/wonderfulMoment',
    name: 'wonderfulMoment',
    component: () => import('@/views/wonderfulMoment/index.vue'),
    meta: {
      title: '精彩瞬间列表',
      keepAlive: false
    },
  },
  {
    path: '/partnmeredia',
    name: 'partnmeredia',
    component: () => import('@/views/partnmeredia/index.vue'),
    meta: {
      title: '合作媒体列表',
      keepAlive: false
    },
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import('@/views/newsList/index.vue'),
    meta: {
      title: '新闻列表',
      keepAlive: false
    },
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('@/views/newsDetail/index.vue'),
    meta: {
      title: '新闻详情'
    },
  },
  {
    path: '/exhibitionTraffic',
    name: 'exhibitionTraffic',
    component: () => import('@/views/exhibitionTraffic/index.vue'),
    meta: {
      title: '展会交通',
      keepAlive: true
    },
  },
  {
    path: '/sessionHpdetail/:id',
    name: 'sessionHpdetail',
    component: () => import('@/views/sessionHpdetail/index.vue'),
    meta: {
      title: '展会概况',
      keepAlive: false
    },
  },
  {
    path: '/exhibitionProcess',
    name: 'exhibitionProcess',
    component: () => import('@/views/exhibitionProcess/index.vue'),
    meta: {
      title: '参展流程',
      keepAlive: true
    },
  },
  {
    path: '/recruitmentDetails',
    name: 'recruitmentDetails',
    component: () => import('@/views/recruitmentDetails/index.vue'),
    meta: {
      title: '招聘详情',
      keepAlive: false
    },
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('@/views/application/index.vue'),
    meta: {
      title: '参展申请',
      keepAlive: true
    },
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/views/application/apply.vue'),
    meta: {
      title: '参展申请',
      keepAlive: true
    },
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/application/success.vue'),
    meta: {
      title: '参展申请',
      keepAlive: true
    },
  },
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
